// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentModel } from '@okcargo-apps/services';

export const environment: EnvironmentModel = {
  production: true,
  apiUrl: 'https://team.demo.okcargo.io',
  apiDemoUrl: 'https://team.okcargo.io',
  versionsUrl: 'https://team.demo.okcargo.io',
  carriersAppUrl: 'https://carriers.okcargo.io',
  shippersAppUrl: 'https://shippers.okcargo.io',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
